import cn from "classnames";
import Box from "@mui/material/Box";
import { ImgBgResponsive } from "@/src/component/base/ImgBgResponsive";
import { StrapiComponentType, ComponentType } from "@/src/type";
import { LoadFromCDN } from "@/src/util";

import { SectionModule, TextModule } from "@/src/component/partial/__module__";

import styles from "./ImageGallery.module.scss";

interface ImageGalleryProps extends ComponentType.DynamicPageSectionComponentProps<StrapiComponentType.Section.ImageGallery> {}

function ImageGallery({ section, slug, snapToGrid, classes, searchParams, quality, lazy }: ImageGalleryProps) {
  const imageGallery: StrapiComponentType.Section.ImageGallery = section.type?.[0];
  return (
    <SectionModule
      section={section}
      slug={slug}
      classes={{
        section: cn(styles.section, classes?.section),
        styledContainer: styles.inner,
      }}
      stylePrefix="ImageGallery"
      styleContainerId={imageGallery.id}
      snapToGrid={snapToGrid}
      searchParams={searchParams}
      quality={quality}
      lazy={lazy}
    >
      <Box className={styles.title}>
        <TextModule text={section.title} />
      </Box>
      <TextModule text={imageGallery.subtitle} />
      <div className={styles.gallery}>
        {(imageGallery?.images ?? []).map((opt) => (
          <ImgBgResponsive
            key={opt.id}
            imageUrl={LoadFromCDN.nextGenFormat(opt.primary.data.attributes.url)}
            className={styles.image}
            prefetch={lazy === "eager"}
          />
        ))}
      </div>
    </SectionModule>
  );
}

export default ImageGallery;
